import { DEFAULT_LANG } from 'app-config';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, } from 'react-i18next';


import en from './en.json';
import ru from './ru.json';

const resources = {
  ru: {
    translation: ru
  },
  en: {
    translation: en
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: DEFAULT_LANG,
    resources,
    debug: true,
    interpolation: {
      escapeValue: false
    }
  });

console.log(i18n.resolvedLanguage);

export default i18n;
